import { createFileRoute } from '@tanstack/react-router'
import { BambooIntrospectPage } from '@/common/components/bamboo-introspect-page/BambooIntrospectPage'

export const Route = createFileRoute('/org/bamboo-introspect')({
  component: BambooIntrospectPage,
})
